import { Component, Element, h, Prop, State, Host } from '@stencil/core';
import { CssClassMap } from '../globals';

@Component({
  tag: 'yth-navbar',
  styleUrl: 'yth-navbar.scss',
  shadow: true,
})
export class YthNavbar {
  @Prop({ reflect: true }) variant?: 'default' | 'subtle' = 'default';
  @Prop({ reflect: true }) placement?: 'top' | 'bottom' | 'left' = 'bottom';
  @Prop({ reflect: true }) zindex?: number = null;
  @Prop({ reflect: true }) fullWidth?: boolean;

  @Element() element: HTMLElement;
  @State() private removeInlinePaddingState: boolean = false;

  render() {
    return (
      <Host class={this.getCssClassMap()} style={this.getStyleMap()}>
        <yth-stack direction="column" gap="zero">
          <slot></slot>
          <slot name="tabs"></slot>
        </yth-stack>
      </Host>
    );
  }

  componentDidLoad() {
    // Initial check for nav items
    this.removeInlinePadding();

    // Optional: Set up a mutation observer to watch for changes in slot content
    const slot = this.element.shadowRoot?.querySelector('slot:not([name])') as HTMLSlotElement;
    if (slot) {
      slot.addEventListener('slotchange', () => {
        this.removeInlinePadding();
      });
    }
  }

  private removeInlinePadding(): boolean {
    if (this.placement !== 'bottom') {
      return false;
    }

    const slot = this.element.shadowRoot.querySelector('slot:not([name])') as HTMLSlotElement;
    const assignedElements = slot?.assignedElements() || [];

    this.removeInlinePaddingState = assignedElements.some(element => element.tagName.toLowerCase() === 'yth-nav-item');
  }

  private getCssClassMap(): CssClassMap {
    return {
      [this.variant]: true,
      'no-inline-padding': this.removeInlinePaddingState
    };
  }

  private getStyleMap(): { [key: string]: string } {
    return this.zindex !== null ? { 'z-index': String(this.zindex) } : {};
  }
}
